import React, { useState } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

const QRPHDoorStickerMerch = ({ navigation }) => {
  const [visibleSticker, setVisibleSticker] = useState("");
  
  const handleBack = () => {
    navigation.previous();
  };

  const handleNext = () => {
    if (!visibleSticker) {
      toast.error("Please select Yes or No", { autoClose: 2000, hideProgressBar: true, theme: 'colored' });
      return;
    }
    if (visibleSticker === 'Yes') {
      if (navigation && navigation.go) navigation.go('qrph-door-sticker-details');
    } else {
      if (navigation && navigation.go) navigation.go('not-visible-qrph-door-sticker');
    }
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">QRPH Door Sticker Merchandising</h4>
              <p className="form-desc">Fill in the details for QRPH door sticker merchandising.</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                  {/* Visible QRPH door sticker */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">Visible QRPH door sticker</Form.Label>
                    <div className="form-radio-group">
                      {[
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" }
                      ].map((opt, index) => (
                        <div
                          key={`qrph-door-sticker-${index}-${opt.value}`}
                          className={`form-radio-item${visibleSticker === opt.value ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="qrph_door_sticker_visible"
                              value={opt.value}
                              label={opt.label}
                              checked={visibleSticker === opt.value}
                              onChange={(e) => setVisibleSticker(e.target.value)}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </Form.Group>

                  <div className="form-nav-btns">
                    <AppButton onClick={handleBack} variant="back" className="form-btn variant-secondary">
                      ← Back
                    </AppButton>
                    <AppButton onClick={handleNext} variant="next" className="form-btn variant-primary">
                      Next  →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default QRPHDoorStickerMerch;

